import * as Sentry from "@sentry/vue";
import { PRODUCTION } from "../utils/envs.js";

const initSentry = function (app, routes) {
    const tracesSampleRate = APP_ENV === PRODUCTION ? 0.1 : 1.0;

    const dsn = {
        noshow: "https://325f37eeaa8a2495a7ff6167e513946f@o4509167446523904.ingest.de.sentry.io/4509129412051024",
        yservices: "https://bafc93809f058307ac8c7ae89b113c69@o4509167446523904.ingest.de.sentry.io/4509129426010192",
    };

    Sentry.init({
        app,
        dsn: dsn[THEME],
        tracesSampleRate,
        logErrors: true,
        environment: APP_ENV,
        integrations: [Sentry.browserTracingIntegration({ router: routes })],
        /*
         * Uncomment to test in local environment without actually sending event to Sentry
         * Compilation must be used with env ENABLE_SENTRY=1, such as:
         * `ENABLE_SENTRY=1 yarn watch`
         */
        // beforeSend(event) {
        //     console.error("Sentry event catched");
        //     console.error(event);
        //     return null;
        // },
    });
};

const testSentry = function () {
    const mustThrow = location.href.indexOf("must_throw_exception") !== -1;

    if (!mustThrow) {
        return;
    }

    const randomString = Math.random().toString(20).substring(2);

    console.info("Throwing an exception to test Sentry (%s)", randomString);

    setTimeout(() => {
        throw "Test exception " + randomString;
    }, 2000);
};

export { initSentry, testSentry };
